// extracted by css-extract-rspack-plugin
export default {"cls1":"mentions_milestone_ping-cls1_Crb","cls2":"mentions_milestone_ping-cls2_5yy mentions_milestone_ping-cls1_Crb"};